
<!-- MODAL HEADER-->
<div class="row modal-bar">

  <div class="col-sm-6"><h5 class="modal-title">{{ passedData.title }}</h5></div>

  <div class="col-sm-6">
      <div class="modal-actions">
          <div class="modal-close">
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="dialogRef.close(false);"></button>
          </div>
      </div>
  </div>
</div>

<form [formGroup]="form" class="form-content">

  <div class="row">
    <div class="col-md-6">
      <div class="important-info info-highlight">

        <div class="row">
          <div class="col-5">
            <p class="info-label">{{'SALES.ORDERS.DETAILS.LABEL.ORDERCUSTOMER' | translate}}</p>
            <p class="info-data">{{this.billingCustomer.Name}}</p>
          </div>
          <div class="col-1">
            <i class="fas fa-user"></i>
          </div>
          <div class="col-5">
            <p class="info-label">{{'SALES.ORDERS.DETAILS.LABEL.TOTAL-AMOUNT' | translate}}</p>
            <p class="info-data">
              {{ calculateTotal('Total') | currency:'EUR' }}
            </p>
          </div>
          <div class="col-1">
            <i class="far fa-credit-card"></i>
          </div>
        </div>

      </div>
    </div>


    <div class="col-lg-6">

      <div class="row">
        <div [ngClass]="form.value.PayByInvoice === '1' ? 'col-3 col-sm-3 col-xs-6' : 'col-6'">
          <div class="form-group">
            <label class="form-control-label d-block">{{'SALES.ORDERS.DETAILS.LABEL.PAYMENT-METHOD' | translate}}<span class="tx-danger">*</span></label>

            <div class="form-check me-3 mb-3 d-inline-block">
              <input class="form-check-input" type="radio" id="PayDirect" formControlName="PayByInvoice" value="0" checked="true">
              <label class="form-check-label">
                {{'SALES.ORDERS.DETAILS.LABEL.DIRECT-PAYMENT' | translate}}
              </label>
            </div>

            <div class="form-check me-3 mb-3 d-inline-block">
              <input class="form-check-input" type="radio" id="PayByInvoice" formControlName="PayByInvoice" value="1" checked="true">
              <label class="form-check-label">
                {{'SALES.ORDERS.DETAILS.LABEL.INVOICE' | translate}}
              </label>
            </div>

          </div>
        </div>
        @if (this.form.value.PayByInvoice === '1') {
        <div class="col-3 col-sm-3 col-xs-6">
          <div class="form-group">
            <label class="form-control-label d-block">{{'SALES.ORDERS.DETAILS.LABEL.PROCESS-INVOICE' | translate}}<span class="tx-danger">*</span></label>

            <div class="ng-input">
              <ng-select [items]="invoiceBatchOptions" bindLabel="Name" bindValue="Value" [ngModel]="defaultInvoiceBatchOption.Value" formControlName="IncludeInInvoiceBatch" [clearable]="false" notFoundText="{{ 'GENERIC.EDITDIALOG.PLACEHOLDER.NOITEMSFOUND' | translate}}"></ng-select>
            </div>

          </div>
        </div>
        }
        <div class="col-6">
          @if (this.billingCustomer.CustomerType === 1) {
          <div class="form-group">
            <label class="form-control-label">
              {{'SALES.ORDERS.DETAILS.LABEL.ACCOUNTMANAGER' | translate}}<span class="tx-danger">*</span>
            </label>
            <ng-select [items]="accountManagers" bindLabel="Name" bindValue="Id" formControlName="AccountManagerId" placeholder="{{'SALES.ORDERS.DETAILS.PLACEHOLDER.ACCOUNTMANAGER' | translate}}" [clearable]="false" notFoundText="{{ 'GENERIC.EDITDIALOG.PLACEHOLDER.NOITEMSFOUND' | translate}}"></ng-select>
          </div>
          }
        </div>
      </div>

      <div class="form-group">
        <div class="row">
          <div class="col-6">
            <label class="form-control-label">{{'SALES.ORDERS.DETAILS.LABEL.DELIVERY-METHOD' | translate}}<span class="tx-danger">*</span></label>
            <ng-select [items]="deliveryMethods" bindLabel="Name" bindValue="Id" formControlName="DeliveryMethodId" placeholder="{{'SALES.ORDERS.DETAILS.PLACEHOLDER.DELIVERY-METHOD' | translate}}" [clearable]="false" notFoundText="{{ 'GENERIC.EDITDIALOG.PLACEHOLDER.NOITEMSFOUND' | translate}}" (change)="onDeliveryMethodChange($event)"></ng-select>
          </div>
          <div class="col-6">
            <label class="form-control-label">{{'SALES.ORDERS.DETAILS.LABEL.ORDER-REFERENCE' | translate}}<span class="tx-danger"></span></label>
            <input class="form-control" name="Reference" formControlName="Reference" placeholder="{{'SALES.ORDERS.DETAILS.PLACEHOLDER.ORDER-REFERENCE' | translate}}" maxlength="64">
          </div>
        </div>

      </div>

    </div>

  </div>

</form>


<t4-tabs>

  <t4-tab tabTitle="{{'SALES.ORDERS.DETAILS.TABS.TITLE.ORDER-LINES' | translate}}" id="orderlines">

    <div class="object-actions text-end">
      <button (click)="openOrderLinesPriceComponent()" [disabled]="selectedObjects.length == 0" class="btn btn-default" class="btn btn-primary border btn-small" type="button"><i class="far fa-edit"></i>{{'SALES.ORDERS.DETAILS.BUTTON.EDIT-PRICE' | translate}}</button>
      <button (click)="editOrderLines()" [disabled]="selectedObjects.length == 0" class="btn btn-default" class="btn btn-primary border btn-small" type="button"><i class="far fa-edit"></i>{{'SALES.ORDERS.DETAILS.BUTTON.ORDER-EDIT' | translate}}</button>
      <button (click)="changeTicketCustomer()" [disabled]="selectedObjects.length == 0" class="btn btn-default" class="btn btn-primary border btn-small" type="button"><i class="fa fa-address-card"></i>{{'SALES.ORDERS.DETAILS.BUTTON.TICKET-CHANGE-CUSTOMER' | translate}}</button>
    </div>


    <div class="table-responsive confirm-order">

      <table class="rounded table text-dark table-striped clickable">
        <thead>
          <th><input type="checkbox" #selectAllCheckbox (click)="allSelectionToggle(selectAllCheckbox.checked)" /></th>
          <th>{{'SALES.ORDERS.DETAILS.LISTVIEW.HEADER.PRODUCT' | translate}}</th>
          <th>{{'SALES.ORDERS.DETAILS.LISTVIEW.HEADER.ENTRANCE' | translate}}</th>
          <th>{{'SALES.ORDERS.DETAILS.LISTVIEW.HEADER.TICKET-TEXT' | translate}}</th>
          <th>{{'SALES.ORDERS.DETAILS.LISTVIEW.HEADER.TYPE' | translate}}</th>
          <th>{{'SALES.ORDERS.DETAILS.LISTVIEW.HEADER.SECTION' | translate}}</th>
          <th>{{'SALES.ORDERS.DETAILS.LISTVIEW.HEADER.ROW-SEAT' | translate}}</th>
          <th>{{'SALES.ORDERS.DETAILS.LISTVIEW.HEADER.NAMED' | translate}}</th>
          <th>{{'SALES.ORDERS.DETAILS.LISTVIEW.HEADER.TARIF' | translate}}</th>
          <th class="text-end">{{'SALES.ORDERS.DETAILS.LISTVIEW.HEADER.TOTAL' | translate}}</th>
        </thead>

        <tbody>
          @for (ol of pagedOrderLines; track $index) {

            @switch (ol.ProductType) {

              @case (ProductTypeEnum.Ticket) {
              <tr (click)="toggleSelection(ol)">
                <td class=""><input type="checkbox" [checked]="isItemSelected(ol)" /> </td>
                @if (ol.PassePartoutName == null) {
                <td>
                  {{ol.EventDate | localDateTime }} - {{ol.EventName}}
                </td>
                } @else {
                <td>{{ ol.PassePartoutName | replaceOnEmpty:''}}</td>
                }
                <td style="width: 150px">{{ ol.SelectedSingleEntranceName | replaceOnEmpty: 'SALES.ORDERS.DETAILS.LISTVIEW.ENTRANCE.DEFAULT-ON-EMPTY' }}</td>
                <td style="width: 200px">{{ ol.TicketText | replaceOnEmpty: 'SALES.ORDERS.DETAILS.LISTVIEW.TICKET-TEXT.DEFAULT-ON-EMPTY' }}</td>
                <td style="width: 150px">{{ol.TicketTypeName}}</td>
                <td style="width: 150px">{{ol.ParentSectionName}}</td>
                <td style="width: 120px">{{ol.RowNumber | replaceOnEmpty}} / {{ol.SeatNumber | replaceOnEmpty}}</td>
                <td style="width: 190px" [ngClass]="{'text-danger': ol.TicketCustomerIsBlacklisted, 'fw-bold': ol.TicketCustomerIsBlacklisted}">
                  {{ol.TicketCustomer}}
                  @if (ol.TicketCustomerIsBlacklisted) {
                  <span> {{'SALES.ORDERS.DETAILS.LISTVIEW.BLACKLISTED' | translate}}</span>
                  }
                </td>
                <td style="width: 130px" [class.tx-danger]="ol.PriceVariationName === null">
                  @if (ol.PriceVariationName && ol.PriceVariationName.length > 0 && hasMatchingPriceVariant(ol)) {
                  <mat-select [value]="ol.PriceVariationId" (click)="onInputFieldClick($event)"
                              (selectionChange)="onPriceVariationChange($event, ol)">
                    @for (variation of ol.PriceVariants; track variation.VariantId) {
                    <mat-option [value]="variation.VariantId" class="select-box-option">{{variation.VariationName}}</mat-option>
                    }
                  </mat-select>
                  } @else {
                    {{ol.PriceVariationName | replaceOnEmpty: 'SALES.ORDERS.DETAILS.LISTVIEW.TARIF.DEFAULT-ON-EMPTY'}}
                  }
                </td>
                <td style="width: 105px; text-align: right;">
                  <div (click)="openOrderLinePriceComponent(ol)">{{ol.TotalWoDiscount | currency:'EUR'}}</div>
                </td>
              </tr>
              }
              @case (ProductTypeEnum.Membership) {
              <tr (click)="toggleSelection(ol)">

                <td class=""><input type="checkbox" [checked]="isItemSelected(ol)" /> </td>
                <td class="">{{ol.MembershipName}} </td>

                <td colspan="5"></td>

                <td style="width: 190px" [ngClass]="{'text-danger': ol.TicketCustomerIsBlacklisted, 'fw-bold': ol.TicketCustomerIsBlacklisted}">
                  {{ol.TicketCustomer}}
                  @if (ol.TicketCustomerIsBlacklisted) {
                  <span> {{'SALES.ORDERS.DETAILS.LISTVIEW.BLACKLISTED' | translate}}</span>
                  }
                </td>

                <td style="width: 130px" [class.tx-danger]="ol.PriceVariationName === null">
                  @if (!ol.PassePartoutId && ol.PriceVariationName && ol.PriceVariationName.length > 0 && hasMatchingPriceVariant(ol)) {
                  <mat-select [value]="ol.PriceVariationId" (click)="onInputFieldClick($event)"
                              (selectionChange)="onPriceVariationChange($event, ol)">
                    @for (variation of ol.PriceVariants; track variation.VariantId) {
                    <mat-option [value]="variation.VariantId">{{variation.VariationName}}</mat-option>
                    }
                  </mat-select>
                  } @else {
                    {{ol.PriceVariationName | replaceOnEmpty: 'SALES.ORDERS.DETAILS.LISTVIEW.TARIF.DEFAULT-ON-EMPTY'}}
                  }
                </td>
                <td style="width: 105px" class="text-end">
                  {{ol.TotalWoDiscount | currency:'EUR'}}
                </td>
              </tr>
              }

              @case (ProductTypeEnum.CrossSellProduct) {
              <tr (click)="toggleSelection(ol)">

                <td class=""><input type="checkbox" [checked]="isItemSelected(ol)" /> </td>
                <td class="">{{ol.CrossSellProductName | translate}} - {{ol.CrossSellProductVariantName | translate}}</td>

                <td colspan="6"></td>

                <td style="width: 130px" [class.tx-danger]="ol.PriceVariationName === null">
                  {{ol.PriceVariationName | replaceOnEmpty: 'SALES.ORDERS.DETAILS.LISTVIEW.TARIF.DEFAULT-ON-EMPTY'}}
                </td>
                <td style="width: 105px" class="text-end">
                  {{ol.TotalWoDiscount | currency:'EUR'}}
                </td>
              </tr>
              }

              @case (ProductTypeEnum.DeliveryMethod) {
              <tr (click)="toggleSelection(ol)">
                <td class=""><input type="checkbox" [checked]="isItemSelected(ol)" /> </td>
                <td colspan="8">{{'SALES.ORDERS.DETAILS.LISTVIEW.HEADER.DELIVERY-COST' | translate}}</td>
                <td class="text-end">{{ol.TotalWoDiscount | currency:'EUR'}}</td>
              </tr>
              }

              @case (ProductTypeEnum.PaymentMethod) {
              <tr (click)="toggleSelection(ol)">
                <td class=""><input type="checkbox" [checked]="isItemSelected(ol)" /> </td>
                <td colspan="8">{{'SALES.ORDERS.DETAILS.LISTVIEW.HEADER.MARKUP-PAYMENT-METHOD' | translate}}</td>
                <td class="text-end">{{ol.TotalWoDiscount | currency:'EUR'}}</td>
              </tr>
              }

              @case (ProductTypeEnum.MatchDayPass) {
              <tr (click)="toggleSelection(ol)">
                <td class=""><input type="checkbox" [checked]="isItemSelected(ol)" /> </td>
                <td>{{ ol.MatchDayPassName | replaceOnEmpty}}</td>
                <td colspan="3"></td>
                <td>{{ ol.SectorName }}</td>
                <td></td>
                <td>{{ ol.TicketCustomer | replaceOnEmpty}}</td>
                <td>{{ol.PriceVariationName}}</td>
                <td class="text-end">{{ol.TotalWoDiscount | currency:'EUR'}}</td>
              </tr>
              }

              @default {
              <tr (click)="toggleSelection(ol)">
                <td colspan="11">
                  <span class="fas fa-exclamation-triangle"></span>
                  <span class="mx-2">{{'SALES.ORDERS.DETAILS.LISTVIEW.WARNING.CANNOT-SHOW-LINE' | translate}}</span>
                  <span class="fas fa-exclamation-triangle"></span>
                </td>
              </tr>
              }

            }
          }
        </tbody>
      </table>
    </div>

    <t4-pager [listCounts]="false" (onPage)="doPage($event)" #pagerComponent></t4-pager>
  </t4-tab>

  <t4-tab tabTitle="{{'SALES.ORDERS.DETAILS.TABS.TITLE.DISCOUNTS' | translate}}" id="discountcodes">

    <div class="object-actions text-end">
      <button (click)="addDiscountCode()" class="btn btn-default" class="btn btn-primary border btn-small" type="button"><i class="far fa-plus-square"></i>{{'SALES.ORDERS.DETAILS.BUTTON.ADDNEW-DISCOUNT' | translate}}</button>
    </div>

    <div class="table-responsive">
      <table class="rounded table text-dark table-striped clickable">
        <thead>
          <th>{{'SALES.ORDERS.DETAILS.LISTVIEW.HEADER.DISCOUNT' | translate}}</th>
          <th class="text-end">{{'SALES.ORDERS.DETAILS.LISTVIEW.HEADER.AMOUNT' | translate}}</th>
        </thead>

        <tbody>
          @if (this.pagedDiscountLines.length == 0) {
            <tr>
              <td colspan="2">{{'SALES.ORDERS.DETAILS.LISTVIEW.EMPTY-DISCOUNT-LINES' | translate}}</td>
            </tr>
          } @else {
            @for (d of pagedDiscountLines; track $index) {
            <tr>
              <td>{{ d.DiscountName | replaceOnEmpty}}</td>
              <td style="width: 80px" class="text-end">{{d.Amount | currency:'EUR'}}</td>
              <td class="grid-action" >
                <button (click)="removeDiscountCode(d.DiscountCodeId)" type="button" class="btn btn-grid btn-round mdi mdi-danger mdi-trash-can-outline"></button>
              </td>
            </tr>
            }
          }
        </tbody>
      </table>
    </div>

    <t4-pager [listCounts]="false" (onPage)="doPageForDiscounts($event)" #pagerComponentForDiscounts></t4-pager>
  </t4-tab>

</t4-tabs>

<div class="mb-3"></div>

<div class="form-layout-footer row">
  <div class="col-6">
    <button [disabled]="saving || validDeliveryMethodSelected == false" (click)="submit()" class="btn btn-block btn-primary bd-0"><i
      class="far fa-save"></i><span>{{'SALES.ORDERS.DETAILS.LABEL.ORDER-SAVE' | translate}}</span></button>
  </div>
  <div class="col-6">
    <button (click)="dialogRef.close(false)" class="btn btn-block btn-secondary bd-0"><i
      class="fas fa-ban"></i><span>{{ 'GENERIC.BUTTON.CANCEL' | translate }}</span></button>
  </div>
</div><!-- form-layout-footer -->
